import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `SuggestionListRoot`
};

export function useSuggestionListStyles() {
  const { effects } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          borderRadius: 2,
          boxShadow: effects.elevation8,
          left: `0px`,
          marginTop: 0,
          maxHeight: `300px !important`,
          overflow: `hidden`,
          textAlign: `left`,
          top: `0px`,
          width: `450px`,
          zIndex: 11
        }
      ]
    }),
    [effects]
  );
}
